import { Navigate } from "react-router-dom";

import Loader from "@/components/ui/loader";
import { useAuth } from "@/contexts/AuthContext";
import { useModuleVisibility, useModuleVisibilityReady } from "@/lib/moduleVisibility";
import { homePathForUser } from "@/lib/roleHome";

/**
 * Route-level twin of the sidebar's module filter: a page whose module the
 * super admin has switched off for the viewer's roles redirects to their home
 * instead of rendering from a bookmark or an in-page link.
 *
 * Sits INSIDE RoleRoute, so there is always a user by the time it renders.
 * Presentation only — the API is still what enforces access to the data.
 */
export default function ModuleRoute({ module, children }: { module: string; children: React.ReactNode }) {
  const { user } = useAuth();
  const ready = useModuleVisibilityReady();
  const isModuleVisible = useModuleVisibility();
  if (!user) return <>{children}</>;
  if (!ready) return <Loader fullScreen />;
  if (!isModuleVisible(module)) return <Navigate to={homePathForUser(user)} replace />;
  return <>{children}</>;
}
